<script setup lang="ts">
const vertical = inject<"top" | "bottom">("vertical");
const horizontal = inject<"start" | "end">("horizontal");
</script>

<template>
  <button
    :class="[
      'content-image-actions-button',
      'group/button',
      'flex items-center justify-center gap-2',
      'w-10 h-10 p-2',
      'bg-white',

      {
        'rounded-b-xl': vertical === 'top',
        'rounded-t-xl': vertical === 'bottom',
        'rounded-e-xl': horizontal === 'start',
        'rounded-s-xl': horizontal === 'end',
      },
    ]"
  >
    <slot v-bind="{ vertical, horizontal }" />
  </button>
</template>
